export default "__VITE_ASSET__DKK3mabu__"